import React from 'react'
import { Col, Row, } from 'reactstrap'
import { Link, NavLink } from 'react-router-dom'
import queryString from 'query-string'

export default function AssessSelectorNav({ overviewLink, skillReportLink, itemReportLink }) {
  function checkoverviewLink(match, location) {
    if (overviewLink === `${location.pathname}${location.search}`) {
      return true
    } else {
      return false
    }
  }
  function checkskillReportLink(match, location) {
    if (skillReportLink === `${location.pathname}${location.search}`) {
      return true
    } else {
      return false
    }
  }
  function checkItemReportLink(match, location) {
    const q = queryString.parse(location.search)
    const itemRepQuery = itemReportLink.split('?')[1]
    const iq = queryString.parse(`?${itemRepQuery}`)
    if (itemReportLink === `${location.pathname}${location.search}`) {
      return true
    } else if (q.a === iq.a && q.g === iq.g && q.item === iq.item) {
      return true
    } else return false
  }
  return (
    <Row className='report-view-links' noGutters>
      <Col xs='12' md='4'>
        <NavLink
          className='report-link overview-report'
          to={overviewLink}
          isActive={checkoverviewLink}
        >
        Overview
      </NavLink>
      </Col>
      <Col xs='12' md='4'>
        <NavLink
          className='report-link skill-report'
          to={skillReportLink}
          isActive={checkskillReportLink}
        >
          Skill Report
        </NavLink>
      </Col>
      <Col xs='12' md='4'>
        <NavLink
          className='report-link item-report'
          to={itemReportLink}
          isActive={checkItemReportLink}
        >
          Item Report
        </NavLink>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSelectorNav.js